import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { interval: { type: Number, default: 15_000 } }

  connect() {
    this.startRefreshing()
  }

  disconnect() {
    this.stopRefreshing()
  }

  startRefreshing() {
    this.stopRefreshing() // Ensure no duplicate intervals
    this.refresh() // Initial refresh
    this.intervalId = setInterval(() => this.refresh(), this.intervalValue)
  }

  stopRefreshing() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  refresh() {
    this.element?.reload()
  }
}
